export default __webpack_public_path__ + "static/media/messageIcon.2bff0e2d.svg";